export const langBaliseList = {
  fr: {
    add: 'Ajouter',
    modify: 'Modifier',
    delete: 'Supprimer',
    search: 'Rechercher',
    name: 'Nom balise',
    id: 'Balise Id',
    dataDispo: 'Data ?',
    alt: 'Alitude (m)',
    dist: 'Dist. au spot (km)',
  },
  eng: {
    add: 'Add',
    modify: 'Modify',
    delete: 'Delete',
    search: 'Search',
    name: 'Station name',
    id: 'Station Id',
    dataDispo: 'Data ?',
    alt: 'Alitude (m)',
    dist: 'Dist. to spot (km)',
  },
}
